
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import CozeRunner from './pages/CozeRunner';
import CozeHomeRunner from './pages/CozeHomeRunner';
import XhsRunner from './pages/XhsRunner';
import Login from './pages/Login';
import Register from './pages/Register';
import Recharge from './pages/Recharge';
import TopicRadar from './pages/TopicRadar';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import MyInfo from './pages/MyInfo';
import './App.css';
import PengyouquanChat from "./pages/PengyouquanChat";
import JinqiangdashuAgent from "./pages/JinqiangdashuAgent";
import CopyAssistant from "./pages/CopyAssistant";
import DealCopyAgent from "./pages/DealCopyAgent";
import TopicPlannerAgent from "./pages/TopicPlannerAgent";
import GodCommentAgent from "./pages/GodCommentAgent";
import WymCopyAgent from "./pages/WymCopyAgent";

function App() {
  return (
    <Router>
      <div className="app-container">
        <Sidebar />
        <div className="main-content">
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/coze-runner" element={<CozeRunner />} />
            <Route path="/xhs-runner" element={<XhsRunner />} />
            <Route path="/douyin-homepage" element={<CozeHomeRunner />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/recharge" element={<Recharge />} />
            <Route path="/topic-radar" element={<TopicRadar />} />
            <Route path="/my" element={<MyInfo />} />
            <Route path="/pengyouquan" element={<PengyouquanChat />} />
            <Route path="/jinqiangdashu" element={<JinqiangdashuAgent />} />
            <Route path="/hook-3s" element={<CopyAssistant />} />
            <Route path="/deal-copy-agent" element={<DealCopyAgent />} />
            <Route path="/topic-planner" element={<TopicPlannerAgent />} />
            <Route path="/god-comment" element={<GodCommentAgent />} />
            <Route path="/wym-copy" element={<WymCopyAgent />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
